export default __webpack_public_path__ + "static/media/how_power_future_poster.8819dff2.jpg";